<template>
  <v-col
    v-if="templateEvents != null && templateEvents.length > 0"
    class="pa-0"
  >
    <template v-for="(tempEvent, index) in templateEvents">
      <EventTemplateOne
        v-if="tempEvent.TemplateType === 1"
        :key="index"
        :eventDetails="tempEvent"
        :showTitle="true"
      />

      <EventTemplateTwo
        v-if="tempEvent.TemplateType === 2"
        :key="index"
        :eventDetails="tempEvent"
        :showTitle="true"
      />

      <EventTemplateThree
        v-if="tempEvent.TemplateType === 3"
        :key="index"
        :eventDetails="tempEvent"
        :showTitle="true"
      />
    </template>
  </v-col>
</template>

<script>
import doRequest from '@/api/dssRequest';

function lazyLoad(component) {
  return () => import(`@/components/homepage/eventTemplates/${component}.vue`);
}

export default {
  name: 'TemplateEvents',
  components: {
    EventTemplateOne: lazyLoad('EventTemplateOne'),
    EventTemplateTwo: lazyLoad('EventTemplateTwo'),
    EventTemplateThree: lazyLoad('EventTemplateThree'),
  },
  data() {
    return {
      templateEvents: [],
    };
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    getTemplates() {
      const payload = {
        IncludeAllPartnersInPartnerGroup: false,
        EventTypes: ['TemplateEvent'],
      };

      this.templateEvents = [];

      doRequest(
        (response) => {
          if (response.data.Events == null) {
            return;
          }

          Object.values(response.data.Events).forEach((event) => {
            this.templateEvents.push(event);
          });
        },
        () => {},
        'getEvents',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
  },
};
</script>
